import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { fetchGrupoPlanes } from '../../actions/planesActions';
import { setTiposGrupoPlanes } from '../../actions/tiposPublicacionActions';
import ReactPaginate from 'react-paginate';

const BusquedaGrupoPlanes = ({
    grupoPlanes,
    fetchGrupoPlanes,
    paginacion,
    setTiposGrupoPlanes,
    tiposPublicacion,
    history,
    editando,
    tiposGruposPlanes
}) => {
    const [estadoGrupoPlanes, setEstadoGrupo] = useState([]);

    useEffect(() => {
        let request = { params: { numeroPagina: 1, cantidadPagina: 10 } };
        fetchGrupoPlanes(request);
        setTimeout(() => {
            comprobarCheckbox();
        }, 500);
    }, []);

    const changeCheck = (params) => {
        addToPlanes(params);
    }

    const addToPlanes = (params) => {
        let arrayGrupo = estadoGrupoPlanes;
        let repetido = arrayGrupo.some(x => x == params);
        if (repetido) {
            let index = arrayGrupo.findIndex(x => x == params);
            if (index !== undefined) {
                arrayGrupo.splice(index, 1);
                setEstadoGrupo(arrayGrupo);
            }
        } else {
            arrayGrupo.push(params);
            setEstadoGrupo(arrayGrupo);
        }
    }

    const agregarGrupoPlanes = () => {
        setTiposGrupoPlanes(estadoGrupoPlanes);
        if (editando) {
            history.push(`/Tipo/Publicaciones/Editar/${tiposPublicacion}`)
        } else {
            history.push(`/Tipo/Publicaciones/Nuevo`)
        }
    }

    const handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        let request = { params: { numeroPagina: selectedPage, cantidadPagina: 10 } };
        fetchGrupoPlanes(request);
        comprobarCheckbox();
    }

    const comprobarCheckbox = () => {
        let planChecked = [];
        let plan = [];
        let idsIniciales = estadoGrupoPlanes;

        setTimeout(() => {
            for (let i = 0; i < tiposGruposPlanes.length; i++) {
                planChecked.push("check" + tiposGruposPlanes[i].idGrupoPlan);
                let obj = tiposGruposPlanes[i];
                let repetido = idsIniciales.some(item => item.idGrupoPlan == obj.idGrupoPlan);
                if (!repetido) {
                    idsIniciales.push(obj);
                }
            }
            setTiposGrupoPlanes(idsIniciales);

            var inputs = document.getElementsByName('checkBoxes');
            for (let i = 0; i < inputs.length; i++) {
                let element = inputs[i].id;
                plan.push(element);
            }
            for (let i = 0; i < plan.length; i++) {
                document.getElementById(plan[i]).checked = false;
            }
            for (let i = 0; i < planChecked.length; i++) {
                for (let c = 0; c < plan.length; c++) {
                    if (plan[c] == planChecked[i]) {
                        document.getElementById(plan[c]).checked = true;
                    }
                }
            }
        }, 500)
    }

    
    return (
        <div className="container">
            <div className="card row justify-content-center">

                <div className="table-responsive">
                    {grupoPlanes != undefined &&
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Descripción</th>
                                    <th>Comisión</th>
                                    <th>Seleccionar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {grupoPlanes.map((item, index) => {
                                    return (
                                        <tr className="hover-background-color" key={index}>
                                            <td>{item.idGrupoPlan}</td>
                                            <td>{item.descripcion}</td>
                                            <td>
                                                <small className="font-14 applyFont">
                                                    {item.comision}
                                                    <i className="fas fa-percent mx-1" />
                                                </small>
                                            </td>
                                            <td>
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        name="checkBoxes"
                                                        id={"check" + item.idGrupoPlan}
                                                        className="custom-control-input"
                                                        onChange={() => changeCheck(item)}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    )})
                                }
                            </tbody>
                        </table>
                    }
                </div>

                <div className="d-flex">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={paginacion.cantidadTotal / paginacion.cantidadPagina}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={0}
                    />
                </div>

                <div className="row align-items-center justify-content-center mb-3 text-center">
                    <button
                        onClick={() => agregarGrupoPlanes()}
                        className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                    >
                        Seleccionar
                    </button>
                    <div className="col-auto d-inline-flex">
                        <Link to="/Tipo/Publicaciones">
                            <button className="btn btn-sm btn-light waves-effect waves-light col-auto">
                                Salir
                            </button>
                        </Link>
                    </div>
                </div>

            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
    seller: state.general.idSeller,
    editando: state.general.editando,
    paginacion: state.planes.grupoPlanes,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    tiposPublicacion: state.tiposPublicacion.tiposPublicacion.codigo
});

const mapDispatchToProps = (dispatch) => {
    return {
        setTiposGrupoPlanes: (params) => { dispatch(setTiposGrupoPlanes(params)) },
        fetchGrupoPlanes: (request) => { dispatch(fetchGrupoPlanes(request)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BusquedaGrupoPlanes);